import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class SuperscriptionAPI extends ComponentAPI {
    /**
     * Returns an array with the superscription items.
     */
    getData() {
        return this.state.data;
    }
    /**
     * Sets the superscription items.
     *
     * @param data - The superscription items.
     */
    setData(data) {
        if (Array.isArray(data)) {
            this.setState({ data });
        }
    }
    /**
     * Returns if the label is visible.
     */
    isShowLabel() {
        return this.state.showLabel;
    }
    /**
     * Sets if the label should be visible.
     *
     * @param showLabel - If the label should be visible.
     */
    setShowLabel(showLabel) {
        this.setState({ showLabel });
    }
    /**
     * Returns if the title is visible.
     */
    isShowTitle() {
        return this.state.showTitle;
    }
    /**
     * Sets if the title should be visible.
     *
     * @param showTitle - If the title should be visible.
     */
    setShowTitle(showTitle) {
        this.setState({ showTitle });
    }
    /**
     * Returns the title expression.
     */
    getTitleExpression() {
        return this.state.titleExpression;
    }
    /**
     * Sets the title expression.
     *
     * @param titleExpression - The title expression.
     */
    setTitleExpression(titleExpression) {
        this.setState({ titleExpression });
    }
}
export { SuperscriptionAPI, };
//# sourceMappingURL=superscription-api.js.map